module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPHBhdGggZmlsbD0iIzAwMzU4MCIgZD0iTTAgMTg2LjE4Mmg1MTJ2MTM5LjYzNkgweiIvPgogIDxwYXRoIGZpbGw9IiMwMDM1ODAiIGQ9Ik0xMjMuMTUyIDBoMTM5LjYzNnY1MTJIMTIzLjE1MnoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/fi.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/fi.svg
// module chunks = 0